export default function useUiValidations() {
  const alawaysTrue = true; // used to prevent UI alignment bug.
  const checkInput = (val) => !!val || 'Please enter value.';
  const checkSelect = (val) => !!val || 'Please select value.';

  const checkIsRoommateValid = (legalName, digiPenEmail) => {
    if (!legalName || !!digiPenEmail) {
      return true;
    }

    return false;
  };

  // Check for MM/DD/YYYY
  const checkIsValidDate = (val) => {
    const pattern = /^(0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](19|20)\d\d$/;
    return pattern.test(val) || 'Invalid Date, please enter in MM/DD/YYYY format.';
  };

  const checkIsValidComplexCode = (val) => {
    const pattern = /^(.{0,4})$/i;
    return pattern.test(val) || 'Complex Code must be 4 or less characters.';
  };

  const checkIsValidEmail = (val) => {
    const emailPattern = /^(?=[a-zA-Z0-9@._%+-]{6,254}$)[a-zA-Z0-9._%+-]{1,64}@(?:[a-zA-Z0-9-]{1,63}\.){1,8}[a-zA-Z]{2,63}$/;
    return emailPattern.test(val) || 'Invalid email.';
  };
  const checkIsValidEmailOrEmpty = (val) => ((val === '' || !val) ? true : checkIsValidEmail(val));
  const checkIsValidNumber = (val) => {
    const pattern = /^[0-9]*$/i;
    return pattern.test(val) || 'Only numerics allowed.';
  };
  const checkIsValidPhone = (val) => {
    const phonePattern = /^[+]?[0-9]{0,3}[\s]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3,4}[-\s.]?[0-9]{2,9}$/i;
    return phonePattern.test(val) || 'Invalid phone format.';
  };
  const checkIsValidPhoneOrEmpty = (val) => ((val === '' || !val) ? true : checkIsValidPhone(val));
  const checkIsValidUsaPhone = (val) => {
    const phonePattern = /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4}$/i;
    return phonePattern.test(val) || 'Invalid phone format.';
  };
  const checkIsValidDescription = (val) => {
    const result = val ? val.length < 31 : true;
    return result || 'Description cannot exceed 30 characters.';
  };
  const checkIsValidUnitName = (val) => {
    const pattern = /^(.{0,6})$/i;
    return pattern.test(val) || 'Unit must be 6 or less characters.';
  };
  function formatCamelCase(text) {
    if (!text) return '';
    // Add a space before each uppercase letter, except for the first character
    return String(text).replace(/([A-Z])/g, (match, group, offset) => { // eslint-disable-line
      return offset > 0 ? ` ${match}` : match;
    });
  }

  return {
    alawaysTrue,
    checkInput,
    checkIsRoommateValid,
    checkIsValidComplexCode,
    checkIsValidDate,
    checkIsValidPhone,
    checkIsValidPhoneOrEmpty,
    checkIsValidEmail,
    checkIsValidEmailOrEmpty,
    checkIsValidNumber,
    checkIsValidDescription,
    checkIsValidUnitName,
    checkIsValidUsaPhone,
    checkSelect,
    formatCamelCase,
  };
}
